


















import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { INumberRangeAlertBehavior, ThresholdAlertBehavior } from "../../../../domain/format/objects";
import { default as ThresholdAlertEditor } from "./ThresholdAlertEditor.vue";

@Component({
  components: {
    ThresholdAlertEditor,
  }
})
export default class NumberRangeAlertBehaviorEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: INumberRangeAlertBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: INumberRangeAlertBehavior) => T, defaultValue: T) => T;

  get upper(): ThresholdAlertBehavior<number> {
    return this.readPropertyOrDefault(s => ThresholdAlertBehavior.from(s.upper) , null);
  }

  set upper(value: ThresholdAlertBehavior<number>) {
    this.writePropertyWhenValid(s => s.upper = ThresholdAlertBehavior.to(value));
  }

  get lower(): ThresholdAlertBehavior<number> {
    return this.readPropertyOrDefault(s => ThresholdAlertBehavior.from(s.lower) , null);
  }

  set lower(value: ThresholdAlertBehavior<number>) {
    this.writePropertyWhenValid(s => s.lower = ThresholdAlertBehavior.to(value));
  }

  // 負の数を使用するためNumber.MIN_SAFE_INTEGERを使用する
  // 最小値、最大値の指標のため、小数点以下の入力は可能
  get minThreshold(): number {
    const min = this.lower.isEnable ? this.lower.threshold : (Number.MIN_SAFE_INTEGER || -(Math.pow(2, 53) - 1)); // MIN_SAFE_INTEGERはIEは未定義のため
    return min;
  }

  get maxThreshold(): number {
    const max = this.upper.isEnable ? this.upper.threshold : (Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1);    // MAX_SAFE_INTEGERはIEは未定義のため
    return max;
  }
}
